import styles from './styles.module.scss';
import classNames from 'classnames';
import {ISideBarItem} from '../index';
import {Link, useLocation} from 'react-router-dom';

const SidebarListItem = ({data}: {data: ISideBarItem[]}) => {
  const location = useLocation();
  return (
    <>
      {data.map((item: ISideBarItem, index: number) => {
        const {Icon, name, routPath, children, className} = item;
        const isActive = location.pathname.includes(routPath);
        return (
          <li className={classNames(styles.item, {[styles.active]: isActive}, className && styles[className])} key={`item_${index}`}>
            {!!children ? (
              <div className={styles.text}>
                <div className={styles.iconBox}>
                  <Icon />
                </div>
                {name}
              </div>
            ) : (
              <Link to={routPath} className={styles.text}>
                <div className={styles.iconBox}>
                  <Icon />
                </div>
                {name}
              </Link>
            )}
          </li>
        );
      })}
    </>
  );
};

export default SidebarListItem;
